"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGameEventDataResponseAllOfToJSON = exports.GetGameEventDataResponseAllOfFromJSONTyped = exports.GetGameEventDataResponseAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetGameEventDataResponseAllOfFromJSON(json) {
    return GetGameEventDataResponseAllOfFromJSONTyped(json, false);
}
exports.GetGameEventDataResponseAllOfFromJSON = GetGameEventDataResponseAllOfFromJSON;
function GetGameEventDataResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventDumps': !(0, runtime_1.exists)(json, 'eventDumps') ? undefined : (json['eventDumps'].map(_1.GameEventDataFromJSON)),
    };
}
exports.GetGameEventDataResponseAllOfFromJSONTyped = GetGameEventDataResponseAllOfFromJSONTyped;
function GetGameEventDataResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventDumps': value.eventDumps === undefined ? undefined : (value.eventDumps.map(_1.GameEventDataToJSON)),
    };
}
exports.GetGameEventDataResponseAllOfToJSON = GetGameEventDataResponseAllOfToJSON;
